import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const SugarSachets = () => <ProductDetailPage {...getProductPageConfig('sugarSachets')} />;

export default SugarSachets;
